import render from './render'

export default {
  name: 'Item',

  props: {
    value: {
      type: Object,
      default: () => {
        return {}
      }
    },

    service: {
      type: String,
      required: true
    }
  },

  render
}
